export default __webpack_public_path__ + "dd4deafe3e1a001cabaa1ec665f4d103.wasm";